// import React, { useState } from "react";
// import {
//   Button,
//   Divider,
//   EmployeeHeader,
//   InfoTimeCard,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../../components";
// import { dateFormator, mapTableRows } from "../../../../utils";
// import { invoicesTableData } from "../../../../assets/data/candidatesData";
// import InvoiceDetails from "./Invoices/InvoiceDetails";
// import ReceivePayment from "./Invoices/ReceivePayment";
// import EditInvoice from "./Invoices/EditInvoice";
// import ViewApprovals from "./Invoices/ViewApprovals";

// const Invoices = () => {
//   const [selectedInvoice, setSelectedInvoice] = useState();
//   const [receivePayment, setReceivePayment] = useState(false);
//   const [editInvoice, setEditInvoice] = useState(false);
//   const [viewApprovals, setViewApprovals] = useState(false);

//   const tableData = invoicesTableData;
//   const columns = [
//     {
//       key: "invoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <div
//           className="flex items-center gap-1 cursor-pointer"
//           onClick={() => setSelectedInvoice(row)}
//         >
//           <span className="text-linkblue cursor-pointer">
//             {row.invoiceNumber}
//           </span>
//         </div>
//       ),
//     },

//     {
//       key: "employee",
//       label: "Employee",
//     },

//     {
//       key: "client",
//       label: "Client",
//     },
//     {
//       key: "clientCode",
//       label: "Client Code",
//     },
//     {
//       key: "invoiceDate",
//       label: "Invoice Date",
//       render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
//     },
//     {
//       key: "shippedDate",
//       label: "Shipped Date",
//       render: (row) => dateFormator(row.shippedDate, "month-day-year"),
//     },
//     {
//       key: "invoiceDueDate",
//       label: "Invoice Due Date",
//       render: (row) => dateFormator(row.invoiceDueDate, "month-day-year"),
//     },

//     {
//       key: "invoicedAmount",
//       label: "Invoiced Amount",
//     },
//     {
//       key: "receivedAmount",
//       label: "Received Amount",
//     },
//     {
//       key: "dueAmount",
//       label: "Due Amount",
//     },
//     {
//       key: "homeCurrency",
//       label: "Home Currency",
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2 flex-row">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//         </div>
//       ),
//     },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);

//   return (
//     <div className="mt-3 flex-1 flex flex-col gap-2 pl-2 pr-6">
//       <div className="pl-2">
//         <PageHeader
//           Section={<EmployeeHeader />}
//           RightSection={
//             (selectedInvoice && !receivePayment ) || editInvoice ? (
//               <div className="flex gap-3">
//                 <Button
//                   size="sm"
//                   title={"Back"}
//                   icon={"arrow_left_alt"}
//                   onClick={() => {
//                     setSelectedInvoice(null);
//                     setEditInvoice(false);
//                   }}
//                 />
//               </div>
//             ) : (
//               ""
//             )
//           }
//         />
//       </div>
//       <div>
//         {!receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             {selectedInvoice ? (
//               <InvoiceDetails
//                 invoice={selectedInvoice}
//                 onBack={() => setSelectedInvoice(null)}
//                 setReceivePayment={setReceivePayment}
//                 setEditInvoice={setEditInvoice}
//               />
//             ) : (
//               <div>
//                 <div>
//                   <PageHeader
//                     Section={
//                       <div className="flex">
//                         <PageTitle
//                           title={"INVOICES"}
//                           icon={"receipt_long"}
//                           tag="p"
//                           size={"sm"}
//                           gap="gap-1"
//                         />
//                       </div>
//                     }
//                   />
//                   <Divider />
//                 </div>
//                 <div className="mt-3">
//                   <PageHeader
//                     RightSection={
//                       <div className="flex gap-2">
//                         <InfoTimeCard
//                           title="Total Amount Invoiced"
//                           color="info"
//                           value={"1794473.11"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Total Amount Received"
//                           color="success"
//                           value={"1646639.38"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Due Amount"
//                           color="primary"
//                           value={"147833.72"}
//                           suffix={"USD"}
//                           type2
//                         />
//                       </div>
//                     }
//                   />
//                 </div>
//                 <div>
//                   <NewTable
//                     rows={mappedRows}
//                     columns={columns}
//                     toolbarRight={[{ hideToolbar: true }]}
//                   />
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//         {receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             <ReceivePayment onBack={() => setReceivePayment(false)} />
//           </>
//         )}
//         {editInvoice && !viewApprovals && (
//           <>
//             <EditInvoice setViewApprovals={setViewApprovals} />
//           </>
//         )}
//         {viewApprovals && <ViewApprovals />}
//       </div>
//     </div>
//   );
// };

// export default Invoices;
// import React, { useState } from "react";
// import {
//   Button,
//   Divider,
//   EmployeeHeader,
//   InfoTimeCard,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../../components";
// import { dateFormator, mapTableRows } from "../../../../utils";
// import { invoicesTableData } from "../../../../assets/data/candidatesData";
// import InvoiceDetails from "./Invoices/InvoiceDetails";
// import ReceivePayment from "./Invoices/ReceivePayment";
// import EditInvoice from "./Invoices/EditInvoice";
// import ViewApprovals from "./Invoices/ViewApprovals";

// const Invoices = () => {
//   const [selectedInvoice, setSelectedInvoice] = useState();
//   const [receivePayment, setReceivePayment] = useState(false);
//   const [editInvoice, setEditInvoice] = useState(false);
//   const [viewApprovals, setViewApprovals] = useState(false);
//   // Track navigation history
//   const [navigationHistory, setNavigationHistory] = useState([]);

//   const tableData = invoicesTableData;
//   const columns = [
//     {
//       key: "invoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <div
//           className="flex items-center gap-1 cursor-pointer"
//           onClick={() => {
//             setSelectedInvoice(row);
//             // Update navigation history
//             setNavigationHistory(["main"]);
//           }}
//         >
//           <span className="text-linkblue cursor-pointer">
//             {row.invoiceNumber}
//           </span>
//         </div>
//       ),
//     },

//     {
//       key: "employee",
//       label: "Employee",
//     },

//     {
//       key: "client",
//       label: "Client",
//     },
//     {
//       key: "clientCode",
//       label: "Client Code",
//     },
//     {
//       key: "invoiceDate",
//       label: "Invoice Date",
//       render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
//     },
//     {
//       key: "shippedDate",
//       label: "Shipped Date",
//       render: (row) => dateFormator(row.shippedDate, "month-day-year"),
//     },
//     {
//       key: "invoiceDueDate",
//       label: "Invoice Due Date",
//       render: (row) => dateFormator(row.invoiceDueDate, "month-day-year"),
//     },

//     {
//       key: "invoicedAmount",
//       label: "Invoiced Amount",
//     },
//     {
//       key: "receivedAmount",
//       label: "Received Amount",
//     },
//     {
//       key: "dueAmount",
//       label: "Due Amount",
//     },
//     {
//       key: "homeCurrency",
//       label: "Home Currency",
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2 flex-row">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//         </div>
//       ),
//     },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);

//   // Handle back navigation based on history
//   const handleBackNavigation = () => {
//     const currentHistory = [...navigationHistory];
//     const prevPage = currentHistory.pop();

//     setNavigationHistory(currentHistory);

//     if (currentHistory.length === 0) {
//       // If no history left, go to main view
//       setSelectedInvoice(null);
//       setEditInvoice(false);
//       setViewApprovals(false);
//       setReceivePayment(false);
//     } else {
//       const currentPage = currentHistory[currentHistory.length - 1];

//       if (currentPage === "main") {
//         // Go to main list view
//         setSelectedInvoice(null);
//         setEditInvoice(false);
//         setViewApprovals(false);
//         setReceivePayment(false);
//       } else if (currentPage === "details") {
//         // Go to invoice details
//         setEditInvoice(false);
//         setViewApprovals(false);
//         setReceivePayment(false);
//       } else if (currentPage === "edit") {
//         // Go to edit invoice
//         setEditInvoice(true);
//         setViewApprovals(false);
//         setReceivePayment(false);
//       }
//     }
//   };

//   // Handle navigation to edit from invoice details
//   const handleGoToEdit = () => {
//     setEditInvoice(true);
//     setNavigationHistory([...navigationHistory, "edit"]);
//   };

//   // Handle navigation to view approvals from edit
//   const handleGoToViewApprovals = () => {
//     setViewApprovals(true);
//     setNavigationHistory([...navigationHistory, "approvals"]);
//   };

//   // Handle navigation to receive payment from invoice details
//   const handleGoToReceivePayment = () => {
//     setReceivePayment(true);
//     setNavigationHistory([...navigationHistory, "payment"]);
//   };

//   return (
//     <div className="mt-3 flex-1 flex flex-col gap-2 pl-2 pr-6">
//       <div className="pl-2">
//         <PageHeader
//           Section={<EmployeeHeader />}
//           RightSection={
//             selectedInvoice || editInvoice || viewApprovals ? (
//               <div className="flex gap-3">
//                 <Button
//                   size="sm"
//                   title={"Back"}
//                   icon={"arrow_left_alt"}
//                   onClick={handleBackNavigation}
//                 />
//               </div>
//             ) : (
//               ""
//             )
//           }
//         />
//       </div>
//       <div>
//         {!receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             {selectedInvoice ? (
//               <InvoiceDetails
//                 invoice={selectedInvoice}
//                 onBack={handleBackNavigation}
//                 setReceivePayment={handleGoToReceivePayment}
//                 setEditInvoice={handleGoToEdit}
//               />
//             ) : (
//               <div>
//                 <div>
//                   <PageHeader
//                     Section={
//                       <div className="flex">
//                         <PageTitle
//                           title={"INVOICES"}
//                           icon={"receipt_long"}
//                           tag="p"
//                           size={"sm"}
//                           gap="gap-1"
//                         />
//                       </div>
//                     }
//                   />
//                   <Divider />
//                 </div>
//                 <div className="mt-3">
//                   <PageHeader
//                     RightSection={
//                       <div className="flex gap-2">
//                         <InfoTimeCard
//                           title="Total Amount Invoiced"
//                           color="info"
//                           value={"1794473.11"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Total Amount Received"
//                           color="success"
//                           value={"1646639.38"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Due Amount"
//                           color="primary"
//                           value={"147833.72"}
//                           suffix={"USD"}
//                           type2
//                         />
//                       </div>
//                     }
//                   />
//                 </div>
//                 <div>
//                   <NewTable
//                     rows={mappedRows}
//                     columns={columns}
//                     toolbarRight={[{ hideToolbar: true }]}
//                   />
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//         {receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             <ReceivePayment onBack={handleBackNavigation} />
//           </>
//         )}
//         {editInvoice && !viewApprovals && (
//           <>
//             <EditInvoice
//               setViewApprovals={handleGoToViewApprovals}
//               onBack={handleBackNavigation}
//             />
//           </>
//         )}
//         {viewApprovals && <ViewApprovals onBack={handleBackNavigation} />}
//       </div>
//     </div>
//   );
// };

// export default Invoices;

// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   EmployeeHeader,
//   InfoTimeCard,
//   NewTable,
//   PageHeader,
//   PageTitle,
// } from "../../../../components";
// import { dateFormator, mapTableRows } from "../../../../utils";
// import { invoicesTableData } from "../../../../assets/data/candidatesData";
// import InvoiceDetails from "./Invoices/InvoiceDetails";
// import ReceivePayment from "./Invoices/ReceivePayment";
// import EditInvoice from "./Invoices/EditInvoice";
// import ViewApprovals from "./Invoices/ViewApprovals";

// const Invoices = () => {
//   const [selectedInvoice, setSelectedInvoice] = useState();
//   const [receivePayment, setReceivePayment] = useState(false);
//   const [editInvoice, setEditInvoice] = useState(false);
//   const [viewApprovals, setViewApprovals] = useState(false);
//   // State to control back button visibility
//   const [showBackButton, setShowBackButton] = useState(false);

//   // Update back button visibility based on current view
//   useEffect(() => {
//     // Show back button for any detail view
//     if (selectedInvoice || receivePayment || editInvoice || viewApprovals) {
//       setShowBackButton(true);
//     } else {
//       setShowBackButton(false);
//     }
//   }, [selectedInvoice, receivePayment, editInvoice, viewApprovals]);

//   const tableData = invoicesTableData;
//   const columns = [
//     {
//       key: "invoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <div
//           className="flex items-center gap-1 cursor-pointer"
//           onClick={() => {
//             setSelectedInvoice(row);
//           }}
//         >
//           <span className="text-linkblue cursor-pointer">
//             {row.invoiceNumber}
//           </span>
//         </div>
//       ),
//     },

//     {
//       key: "employee",
//       label: "Employee",
//     },

//     {
//       key: "client",
//       label: "Client",
//     },
//     {
//       key: "clientCode",
//       label: "Client Code",
//     },
//     {
//       key: "invoiceDate",
//       label: "Invoice Date",
//       render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
//     },
//     {
//       key: "shippedDate",
//       label: "Shipped Date",
//       render: (row) => dateFormator(row.shippedDate, "month-day-year"),
//     },
//     {
//       key: "invoiceDueDate",
//       label: "Invoice Due Date",
//       render: (row) => dateFormator(row.invoiceDueDate, "month-day-year"),
//     },

//     {
//       key: "invoicedAmount",
//       label: "Invoiced Amount",
//     },
//     {
//       key: "receivedAmount",
//       label: "Received Amount",
//     },
//     {
//       key: "dueAmount",
//       label: "Due Amount",
//     },
//     {
//       key: "homeCurrency",
//       label: "Home Currency",
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2 flex-row">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//           />
//         </div>
//       ),
//     },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);

//   // Handle back navigation based on current state
//   const handleBackNavigation = () => {
//     // If we're in any detail view, we need to go back based on our current state
//     if (receivePayment) {
//       // If in receive payment, go back to invoice details
//       setReceivePayment(false);
//       return;
//     }

//     if (viewApprovals) {
//       // If in view approvals, go back to edit invoice
//       setViewApprovals(false);
//       return;
//     }

//     if (editInvoice) {
//       // If in edit invoice, go back to invoice details
//       setEditInvoice(false);
//       return;
//     }

//     if (selectedInvoice && !editInvoice && !viewApprovals && !receivePayment) {
//       // If in invoice details, go back to main list
//       setSelectedInvoice(null);
//       return;
//     }

//     // Fallback - clear everything
//     setSelectedInvoice(null);
//     setEditInvoice(false);
//     setViewApprovals(false);
//     setReceivePayment(false);
//   };

//   // Handle navigation to edit from invoice details
//   const handleGoToEdit = () => {
//     setEditInvoice(true);
//   };

//   // Handle navigation to view approvals from edit
//   const handleGoToViewApprovals = () => {
//     setViewApprovals(true);
//   };

//   // Handle navigation to receive payment from invoice details
//   const handleGoToReceivePayment = () => {
//     setReceivePayment(true);
//   };

//   // Debug logging to help diagnose visibility issues

//   return (
//     <div className="mt-3 flex-1 flex flex-col gap-2 pl-2 pr-6">
//       <div className="pl-2">
//         <PageHeader
//           Section={<EmployeeHeader />}
//           RightSection={
//             showBackButton ? (
//               <div className="flex gap-3">
//                 <Button
//                   size="sm"
//                   title={"Back"}
//                   icon={"arrow_left_alt"}
//                   onClick={handleBackNavigation}
//                 />
//               </div>
//             ) : null
//           }
//         />
//       </div>
//       <div>
//         {!receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             {selectedInvoice ? (
//               <InvoiceDetails
//                 invoice={selectedInvoice}
//                 onBack={handleBackNavigation}
//                 setReceivePayment={handleGoToReceivePayment}
//                 setEditInvoice={handleGoToEdit}
//               />
//             ) : (
//               <div>
//                 <div>
//                   <PageHeader
//                     Section={
//                       <div className="flex">
//                         <PageTitle
//                           title={"INVOICES"}
//                           icon={"receipt_long"}
//                           tag="p"
//                           size={"sm"}
//                           gap="gap-1"
//                         />
//                       </div>
//                     }
//                   />
//                   <Divider />
//                 </div>
//                 <div className="mt-3">
//                   <PageHeader
//                     RightSection={
//                       <div className="flex gap-2">
//                         <InfoTimeCard
//                           title="Total Amount Invoiced"
//                           color="info"
//                           value={"1794473.11"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Total Amount Received"
//                           color="success"
//                           value={"1646639.38"}
//                           suffix={"USD"}
//                           type2
//                         />

//                         <InfoTimeCard
//                           title="Due Amount"
//                           color="primary"
//                           value={"147833.72"}
//                           suffix={"USD"}
//                           type2
//                         />
//                       </div>
//                     }
//                   />
//                 </div>
//                 <div>
//                   <NewTable
//                     rows={mappedRows}
//                     columns={columns}
//                     toolbarRight={[{ hideToolbar: true }]}
//                   />
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//         {receivePayment && !editInvoice && !viewApprovals && (
//           <>
//             <ReceivePayment
//               onBack={handleBackNavigation}
//               invoice={selectedInvoice}
//             />
//           </>
//         )}
//         {editInvoice && !viewApprovals && (
//           <>
//             <EditInvoice
//               setViewApprovals={handleGoToViewApprovals}
//               onBack={handleBackNavigation}
//             />
//           </>
//         )}
//         {viewApprovals && <ViewApprovals onBack={handleBackNavigation} />}
//       </div>
//     </div>
//   );
// };

// export default Invoices;

import React, { useState, useEffect } from "react";
import {
  Button,
  Divider,
  EmployeeHeader,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCard,
  InfoTimeCardAdv,
  InfoWrapper,
  Modal,
  NewTable,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { invoicesTableData } from "../../../../assets/data/candidatesData";
import ReceivePayment from "./Invoices/ReceivePayment";
import EditInvoice from "./Invoices/EditInvoice";
import ViewApprovals from "./Invoices/ViewApprovals";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  getCurrentInvoiceStart,
  getEmpAllInvoicesStart,
} from "../../../../redux/slices/invoices/invoicesSlice";
import { formatCurrency } from "../../../../utils/stringUtils";
import InvoiceDetails from "../../Invoices/Invoices/InvoiceDetails";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";

const Invoices = () => {
  const dispatch = useDispatch();
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    loading,
    error,
    employees,
  } = useSelector((state) => state.employee);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    25,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );
  const { value } = useSelector((state) => state.totalCount);
  const [invoicesMetrics, setInvoicesMetrics] = useState({});
  const { empAllInvoices,loading:invoiceLoading } = useSelector((state) => state.invoices);
  const [clientDetails, setClientDetails] = useState({});
  const empAllInvoicesTableData = empAllInvoices?.data || [];
  const totalCount = value?.empInvoice?.data || 0;
  const [selectedInvoice, setSelectedInvoice] = useState();
  const [receivePayment, setReceivePayment] = useState(false);
  const [editInvoice, setEditInvoice] = useState(false);
  const [viewApprovals, setViewApprovals] = useState(false);
  // State to control back button visibility
  const [showBackButton, setShowBackButton] = useState(false);
  const [metricsLoading, setMetricsLoading] = useState(false);

  // Update back button visibility based on current view
  useEffect(() => {
    // Show back button for any detail view
    if ((selectedInvoice && !receivePayment && editInvoice) || viewApprovals) {
      setShowBackButton(true);
    } else {
      setShowBackButton(false);
    }
  }, [selectedInvoice, receivePayment, editInvoice, viewApprovals]);

  const tableData = empAllInvoicesTableData;

  const handleClickForInvoice = (row) => {
    console.log("row", row);
    dispatch(
      getCurrentInvoiceStart({
        filters: { invoiceNum: { type: "NONE", value: row.invoiceNum } },
        coll: "Invoice",
        ref: "Client Employee Placement",
        incl: ["", "firstName lastName"],
      }),
    );
    setSelectedInvoice(row);
  };
  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => {
            handleClickForInvoice(row);
          }}
        >
          <span className="text-linkblue cursor-pointer">{row.invoiceNum}</span>
        </div>
      ),
    },

    {
      key: "employeeName",
      label: "Employee Name",
      render: (row) => {
        return <div>{row?.employeeId?.firstName || "-"}</div>;
      },
    },
    {
      key: "clientId",
      label: "Client",
      render: (row) => {
        return <div>{row?.clientId?.businessName || "-"}</div>;
      },
    },
    {
      key: "clientCode",
      label: "Client Code",
      render: (row) => {
        return <div>{`CLI-${row?.clientId?.uiid}`}</div>;
      },
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    // {
    //   key: "shippedDate",
    //   label: "Shipped Date",
    //   render: (row) => dateFormator(row.shippedDate, "month-day-year"),
    // },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "invoicedAmount",
      label: "Invoiced Amount",
      render: (row) => {
        return <div>{row?.amounts?.invoiced}</div>;
      },
    },
    {
      key: "receivedAmount",
      label: "Received Amount",
      render: (row) => {
        return <div>{formatCurrency(row?.amounts?.received)}</div>;
      },
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => {
        return <div>{row?.amounts?.due}</div>;
      },
    },

    {
      key: "pastDueDays",
      label: "Past Due Days",
      render: (row) => {
        function getPastDueDays(dueDate) {
          const today = new Date();
          const due = new Date(dueDate);
          const diffTime =
            today.setHours(0, 0, 0, 0) - due.setHours(0, 0, 0, 0);
          return Math.floor(diffTime / (1000 * 60 * 60 * 24));
        }

        const pastDueDays =
          row?.amounts?.due === 0
            ? "-"
            : row?.dueDate
              ? getPastDueDays(row?.dueDate)
              : 0;
        return <div>{pastDueDays < 0 ? 0 : pastDueDays}</div>;
      },
    },
    // {
    //   key: "homeCurrency",
    //   label: "Home Currency",
    //   render: (row) => {
    //     return <div>USD</div>;
    //   },
    // },
    // {
    //   key: "actions",
    //   label: "Actions",
    //   render: (row) => (
    //     <div className="flex items-center gap-2 flex-row">
    //       <Button
    //         type="icon"
    //         icon="download"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //       <Button
    //         type="icon"
    //         icon="delete"
    //         size="xs"
    //         variant="text"
    //         color="black"
    //       />
    //     </div>
    //   ),
    // },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  // Handle back navigation based on current state
  const handleBackNavigation = () => {
    // If we're in any detail view, we need to go back based on our current state
    if (receivePayment) {
      // If in receive payment, go back to invoice details
      setReceivePayment(false);
      // setSelectedInvoice(null);
      return;
    }
    if (viewApprovals) {
      // If in view approvals, go back to edit invoice
      setViewApprovals(false);
      return;
    }

    if (editInvoice) {
      // If in edit invoice, go back to invoice details
      setEditInvoice(false);
      setSelectedInvoice(null);

      return;
    }

    if (selectedInvoice && !editInvoice && !viewApprovals && !receivePayment) {
      // If in invoice details, go back to main list
      setSelectedInvoice(null);
      return;
    }

    // Fallback - clear everything
    setSelectedInvoice(null);
    setEditInvoice(false);
    setViewApprovals(false);
    setReceivePayment(false);
  };

  // Handle navigation to edit from invoice details
  const handleGoToEdit = () => {
    setEditInvoice(true);
  };

  // Handle navigation to view approvals from edit
  const handleGoToViewApprovals = () => {
    setViewApprovals(true);
  };

  // Handle navigation to receive payment from invoice details
  const handleGoToReceivePayment = () => {
    setReceivePayment(true);
  };

  // Create a custom configuration object for child components
  // This tells child components NOT to render their own back buttons
  const childComponentProps = {
    suppressBackButton: true, // Flag to tell child components not to show their back button
  };

  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "invoices",
        coll: "Invoice",
        tname: "empInvoice",
        //filters: item.filters,
        filters: { employeeId: { type: "NONE", value: employeeProfileUiid } },
      }),
    );
    dispatch(
      getEmpAllInvoicesStart({
        collection: "invoices",
        coll: "Invoice",
        page: page,
        limit: limit,
        //filters: item.filters,
        ret: "invoiceNum employeeId clientId invoiceDate shippedDate dueDate amounts currency",
        ref: "Client Employee",
        incl: ["businessName uiid", "firstName lastName"],
        filters: {
          employeeId: { type: "NONE", value: employeeProfileUiid },
          ...(clientDetails?.value && {
            clientId: { type: "NONE", value: clientDetails?.value },
          }),
        },
      }),
    );
    const fetchInvoiceMetrics = async () => {
      try {
        setMetricsLoading(true);
        const res = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.INVOICES.GET_ALL,
          params: {
            coll: "Invoice",
            useAggregate: true,
            lim: limit,
            pg: page,
            fil: JSON.stringify({
              invoices: { type: "AG_STATS", value: [employeeProfileUiid] },
            }),
          },
        });
        setInvoicesMetrics(res?.data?.data[0] || {});
      } catch (error) {
        console.error("Error fetching invoice metrics", error);
      } finally {
        setMetricsLoading(false);
      }
    };
    fetchInvoiceMetrics();
  }, [employeeProfileUiid, dispatch, page, limit, clientDetails?.value]);

  return (
    <div className="mt-3 flex-1 flex flex-col gap-2 overflow-hidden">
      <div className="pl-2">
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            showBackButton ? (
              <div className="flex gap-3">
                <Button
                  size="sm"
                  title={"Back"}
                  icon={"arrow_left_alt"}
                  onClick={handleBackNavigation}
                />
              </div>
            ) : (
              <div className="flex gap-3">
                <Button
                  color="primary"
                  size="sm"
                  title={"Back"}
                  icon={"west"}
                  type="link"
                  to="/employee"
                />
              </div>
            )
          }
        />
      </div>
      <div className="flex-1 flex flex-col overflow-hidden">
        {!receivePayment && !editInvoice && !viewApprovals && (
          <>
            <div className="flex-1 flex flex-col overflow-hidden">
              <div>
                <PageHeader
                  Section={
                    <div className="flex">
                      <PageTitle
                        title={"INVOICES"}
                        icon={"receipt_long"}
                        tag="p"
                        size={"sm"}
                        gap="gap-1"
                      />
                    </div>
                  }
                />
                <Divider />
              </div>
              <div className="mt-3">
                <PageHeader
                  RightSection={
                    // <InfoWrapper className={"min-w-[250px]"}>
                    <div className="flex gap-2">
                      <InfoCardNewAdv
                        title="Total Amount Invoiced"
                        value={formatCurrency(invoicesMetrics.invoiced)}
                        valueConfig={{ className: "text-info!" }}
                        layout="option12"
                        isLoading={metricsLoading}
                        />
                      <InfoCardNewAdv
                        title="Total Amount Received"
                        value={formatCurrency(invoicesMetrics.received)}
                        valueConfig={{ className: "text-success!" }}
                        layout="option12"
                        isLoading={metricsLoading}
                        />
                      <InfoCardNewAdv
                        title="Due Amount"
                        value={formatCurrency(invoicesMetrics.due)}
                        layout="option12"
                        isLoading={metricsLoading}
                      />
                    </div>
                    // </InfoWrapper>

                    // <div className="flex gap-2">
                    //   {/* <InfoTimeCardAdv
                    //     title="Total Amount Invoiced"
                    //     // value={Number(
                    //     //   (tableData || []).reduce((sum, record) => {
                    //     //     const invoiced = record?.amounts?.invoiced ?? 0;
                    //     //     return sum + invoiced;
                    //     //   }, 0)
                    //     // ).toFixed(2)}
                    //     value={formatCurrency(invoicesMetrics.invoiced)}
                    //     color="info"
                    //     size="xs"
                    //     prefix=""
                    //     // suffix="USD"
                    //   /> */}
                    //   <InfoCardNewAdv
                    //     title="Total Amount Invoiced"
                    //     titleConfig={{ className: "text-[16px]!" }}
                    //     value={formatCurrency(invoicesMetrics.invoiced)}
                    //     valueConfig={{
                    //       className: "text-[16px]! text-info! leading-none!",
                    //     }}
                    //     prefix=""
                    //     bgConfig={{
                    //       className:
                    //         "bg-gradient-to-b from-white to-white! p-2! shadow-md",
                    //     }}
                    //     layoutConfig={{
                    //       layoutClassName: "flex flex-col gap-2!",
                    //     }}
                    //   />
                    //   {/* <InfoTimeCardAdv
                    //     title={"Total Amount Received"}
                    //     // value={Number(
                    //     //   tableData.reduce((sum, record) => {
                    //     //     const invoiced = record?.amounts?.received ?? 0;
                    //     //     return sum + invoiced;
                    //     //   }, 0)
                    //     // ).toFixed(2)}
                    //     value={formatCurrency(invoicesMetrics.received)}
                    //     color="success"
                    //     size="xs"
                    //     prefix=""
                    //     // suffix="USD"
                    //   /> */}
                    //   <InfoCardNewAdv
                    //     title="Total Amount Received"
                    //     titleConfig={{ className: "text-[16px]!" }}
                    //     value={formatCurrency(invoicesMetrics.received)}
                    //     valueConfig={{
                    //       className: "text-[16px]! text-success! leading-none!",
                    //     }}
                    //     prefix=""
                    //     bgConfig={{
                    //       className:
                    //         "bg-gradient-to-b from-white to-white! p-2! shadow-md",
                    //     }}
                    //     layoutConfig={{
                    //       layoutClassName: "flex flex-col gap-2!",
                    //     }}
                    //   />

                    //   {/* <InfoTimeCard
                    //       title="Due Amount"
                    //       color="primary"
                    //       value={"147833.72"}
                    //       suffix={"USD"}
                    //       type2
                    //     /> */}
                    //   {/* <InfoTimeCardAdv
                    //     title={"Due Amount"}
                    //     // value={Number(
                    //     //   tableData.reduce((sum, record) => {
                    //     //     const invoiced = record?.amounts?.due ?? 0;
                    //     //     return sum + invoiced;
                    //     //   }, 0)
                    //     // ).toFixed(2)}
                    //     value={formatCurrency(invoicesMetrics.due)}
                    //     color="primary"
                    //     size="xs"
                    //     prefix=""
                    //     // suffix="USD"
                    //   /> */}
                    //   <InfoCardNewAdv
                    //     title="Due Amount"
                    //     titleConfig={{ className: "text-[16px]!" }}
                    //     value={formatCurrency(invoicesMetrics.due)}
                    //     valueConfig={{
                    //       className: "text-[16px]! text-primary! leading-none!",
                    //     }}
                    //     prefix=""
                    //     bgConfig={{
                    //       className:
                    //         "bg-gradient-to-b from-white to-white! p-2! shadow-md",
                    //     }}
                    //     layoutConfig={{
                    //       layoutClassName: "flex flex-col gap-2!",
                    //     }}
                    //   />
                    // </div>
                  }
                />
              </div>
              <div className="flex-1 flex overflow-hidden">
                <TableAdv
                  tableId={"employee_invoicestab"}
                  serverPagination={true}
                  totalCount={totalCount}
                  rows={mappedRows}
                  columns={columns}
                  // toolbarRight={[
                  //   { filterButton: false },
                  //   { DropdownMenu: false },
                  // ]}

                  // toolbarRight={[
                  //   { customSearch: false },
                  //   { filterButton: false },
                  //   { DropdownMenu: false },
                  // ]}
                  toolbarRight={{
                    add: [
                      {
                        component: (
                          <div className="min-w-[200px]">
                            <FormFieldSet
                              size="sm"
                              noTitle
                              type="allInvoiceClients"
                              // parentValue={{ or }}
                              placeholder="Select Client"
                              value={clientDetails?.label || ""}
                              onChange={(value) => setClientDetails(value)}
                              showSearch
                              filters={{ employeeId: employeeProfileUiid }}

                              // key={row.id}
                              // options={[
                              //   { value: "Placement 1", label: "Placement 1" },
                              //   { value: "Placement 2", label: "Placement 2" },
                              //   { value: "Placement 3", label: "Placement 3" },
                              // ]}
                            />
                          </div>
                        ),
                      },
                    ],
                  }}
                  page={page}
                  limit={limit}
                  onPaginationChange={setPage}
                  onLimitChange={handleLimitChange}
                />
              </div>
              <Modal
                isOpen={selectedInvoice}
                title={"Invoice Details"}
                onClose={() => setSelectedInvoice(null)}
                showCloseButton={true}
                closeOnOutsideClick={true}
                width="max-w-full"
              >
                <InvoiceDetails
                  invoice={selectedInvoice}
                  onBack={() => setSelectedInvoice(null)}
                  setReceivePayment={handleGoToReceivePayment}
                  setEditInvoice={handleGoToEdit}
                  removeButtonForPreview={true}
                  {...childComponentProps}
                />
              </Modal>
            </div>
          </>
        )}
        {receivePayment && !editInvoice && !viewApprovals && (
          <>
            <ReceivePayment
              onBack={handleBackNavigation}
              invoice={selectedInvoice}
              {...childComponentProps}
            />
          </>
        )}
        {editInvoice && !viewApprovals && (
          <>
            <EditInvoice
              setViewApprovals={handleGoToViewApprovals}
              onBack={handleBackNavigation}
              loading={invoiceLoading}
              {...childComponentProps} // Pass suppressBackButton flag
            />
          </>
        )}
        {viewApprovals && (
          <ViewApprovals
            onBack={handleBackNavigation}
            {...childComponentProps} // Pass suppressBackButton flag
          />
        )}
      </div>
    </div>
  );
};

export default Invoices;
